import { useQuery } from "react-query";
import { API_URL } from "../api";
import { APIError, APIResponse, get } from "../api";

export type ReferralDownline = {
  maskedName: string;
  joinedAt: string | null;
  kycTier: number;
  hasAviationTxn: boolean;
  /** REFERRER grant status for this downline, or "NONE" if not yet rewarded. */
  rewardStatus: string;
};

export type ReferralDownlinesData = {
  items: ReferralDownline[];
  total: number;
  skip: number;
  take: number;
};

export function useReferralDownlines(params: { skip?: number; take?: number } = {}) {
  const token =
    typeof window !== "undefined" ? localStorage.getItem("token") : null;
  const skip = params.skip ?? 0;
  const take = params.take ?? 20;

  return useQuery<APIResponse<ReferralDownlinesData>, APIError>({
    queryKey: ["referral-downlines", token, skip, take],
    queryFn: () =>
      get(
        `${API_URL}/user/account/referrals/downlines?skip=${skip}&take=${take}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      ),
    enabled: !!token,
    retry: false,
    staleTime: 1000 * 60,
  });
}
